import { Platform } from "react-native"

import { promptOpenWebsiteInNewTab } from "src/utils/openWebsiteDialog"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type NavigateFn = (route: any) => void

/**
 * Open a website in the in-app browser on native, or prompt to open in a new tab on web.
 * On web we never navigate to /web-browser because cross-origin embedding is unreliable.
 */
export function openWebsite(url: string, navigate: NavigateFn): void {
  if (!url) return

  if (Platform.OS === "web") {
    promptOpenWebsiteInNewTab(url)
    return
  }

  navigate({ pathname: "/web-browser", params: { url } })
}
